export default __webpack_public_path__ + "static/media/ApeUSD.dbdd2eba.svg";